import { AutotagType, ContentType } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import constants from '../../common/constants';
import ModalDialogButtonV3 from '../common/ModalDialogButtonV3';

export const renderCancelModalButton = (
  variant: 'normal' | 'link',
  disabled: boolean,
  cancel: () => void,
) => {
  return (
    <ModalDialogButtonV3
      variant={variant}
      buttonText={constants.CANCEL_BUTTON_TEXT}
      cancelText={constants.KEEP_WRITING_TEXT}
      header={constants.CANCEL_NEW_CONTENT_TEXT}
      text={constants.CANCEL_CONTENT_INSTRUCTION}
      submitButtonText={constants.CANCEL_NEW_CONTENT_CONFIRMATION}
      onSubmit={cancel}
      disabled={disabled}
      fullwidth
    />
  );
};

export const createContentPageHeaders = new Map<ContentType, string>([
  [ContentType.Pattern, constants.CREATE_PATTERN],
  [ContentType.Guide, constants.CREATE_GUIDE],
]);

export const editContentPageHeaders = new Map<ContentType, string>([
  [ContentType.Pattern, constants.EDIT_PATTERN],
  [ContentType.Strategy, constants.EDIT_STRATEGY],
  [ContentType.Guide, constants.EDIT_GUIDE],
]);

export const finalizeContentPageHeaders = new Map<ContentType, string>([
  [ContentType.Pattern, constants.FINALIZE_PATTERN],
  [ContentType.Strategy, constants.FINALIZE_STRATEGY],
  [ContentType.Guide, constants.FINALIZE_GUIDE],
]);

export const createEditContentPageInstructions = new Map<ContentType, string>([
  [ContentType.Pattern, constants.PATTERN_INSTRUCTION_TEXT],
  [ContentType.Strategy, constants.STRATEGY_INSTRUCTION_TEXT],
  [ContentType.Guide, constants.GUIDE_INSTRUCTION_TEXT],
]);

export const autotagMetadataAttributes = new Set<string>([
  'mainTechDomain',
  'techDomains',
  'awsServices',
  'workload',
]);

export const metadataToAutotagTypeMap = new Map<string, AutotagType>([
  ['techDomains', AutotagType.Technology],
  ['awsServices', AutotagType.AwsService],
  ['workload', AutotagType.Workload],
]);

export const metadataToAutotagDisplayMap = new Map<string, string>([
  ['techDomains', 'additional technology'],
  ['awsServices', 'AWS Service'],
  ['workload', 'workload'],
]);
